import createApp from '@shopify/app-bridge';
import { authenticatedFetch } from '@shopify/app-bridge-utils';

let app = null;
let appFetch = null;

export function initApp() {
  if (window.location.host.indexOf('localhost') !== -1) {
    return 'localhost';
  }

  const params = new URLSearchParams(window.location.search);
  const host = params.get('host');

  if (!host) return null;

  app = createApp({
    apiKey: 'a68d9481c89610db9306ba8b29f250dc',
    host,
    forceRedirect: true,
  });

  appFetch = authenticatedFetch(app);

  return app;
}

export function getAppFetch() {
  return appFetch || window.fetch.bind(window);
}

export function getApp() {
  return app;
}
